import { PeekInHybrid } from "./PeekInHybrid";
import type { TypePeekInProps } from "./PeekInTypes";

/**
 * PeekIn component. Automatically routes between the Tailwind implementation
 * (preferred) and the styled-system implementation (for consumers using system
 * props or a styled() extension).
 *
 * Defined as a self-named component (rather than a bare re-export of
 * PeekInHybrid) so the `react-docgen` props-docs generation in the Publish
 * pipeline has a suitable component definition to analyze.
 */
export const PeekIn = (props: TypePeekInProps) => <PeekInHybrid {...props} />;

PeekIn.displayName = "PeekIn";

export {
  PeekInHeader,
  PeekInContent,
  PeekInFooter,
  PeekInPanel,
  PeekInTrigger,
} from "./components";
